import React, { useMemo, useState } from "react";
import { ForceGraph2D } from "react-force-graph";

const GraphVisualization = ({ nodes, edges }) => {
  // Hover edilen node'u tutmak için state
  const [hoveredNode, setHoveredNode] = useState(null);

  // Graph verisini oluştur
  const graphData = useMemo(() => {
    return {
      nodes: nodes.map((node) => ({
        id: node.id,
        name: node.name,
        lat: node.lat,
        log: node.log,
      })),
      links: edges.map((edge) => ({
        source: edge[0],
        target: edge[1],
      })),
    };
  }, [nodes, edges]);

  // Node üzerine gelindiğinde çalışacak fonksiyon
  const handleNodeHover = (node) => {
    setHoveredNode(node); // Hover edilen node'u state'e kaydet
  };

  return (
    <div style={{ position: "relative", width: "100%", height: "auto" }}>
      {/* Hover edilen node'un bilgisini gösteren tooltip */}
      {hoveredNode && (
        <div
          style={{
            position: "absolute",
            top: 10,
            left: 10,
            backgroundColor: "white",
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
            zIndex: 10,
          }}
        >
          <strong>{hoveredNode.name}</strong>
          <div>Lat: {hoveredNode.lat}</div>
          <div>Log: {hoveredNode.log}</div>
        </div>
      )}

      {/* ForceGraph2D bileşeni */}
      <ForceGraph2D
        graphData={graphData}
        onNodeHover={handleNodeHover} // Node hover event'i
        nodeLabel="name" // Node üzerinde gösterilecek label
        nodeAutoColorBy="id" // Node'ları ID'ye göre renklendir
        linkDirectionalArrowLength={3.5} // Okların uzunluğu
        linkDirectionalArrowRelPos={1} // Okların konumu
        linkCurvature={0.25} // Linklerin eğriliği
        nodeCanvasObject={(node, ctx, globalScale) => {
          // Node'ların yanında ID'leri göstermek için özelleştirilmiş çizim
          const label = `${node.id}`; // Node ID'sini al
          const fontSize = 12 / globalScale; // Yazı boyutunu ayarla
          ctx.font = `${fontSize}px Sans-Serif`;
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillStyle = "black"; // Yazı rengi
          ctx.fillText(label, node.x, node.y + 10); // ID'yi node'un altında göster
        }}
      />
    </div>
  );
};

export default GraphVisualization;